import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { getControlDevice } from '../../utils/status-line';
import { Box } from '@mui/material';
import { removeNulls } from 'utils';
export const ControlDevicesIndicator = memo(function ControlDevicesIndicator(props) {
    const { heating_circuit, z3k_config, z3k_state, hide_relay, ...rest } = props;
    const icons = useMemo(() => removeNulls(heating_circuit.control_devices.map((id) => {
        const control_device = getControlDevice(id, z3k_config, z3k_state, {
            hide_relay,
        });
        if (!control_device) {
            return null;
        }
        const { icon } = control_device;
        return icon;
    })), [heating_circuit, z3k_config, z3k_state, hide_relay]);
    if (icons.length == 0) {
        return null;
    }
    return (_jsx(Box, { display: "flex", alignItems: "center", columnGap: 1, justifyContent: "center", ...rest, children: heating_circuit.control_devices.map((id) => {
            const control_device = getControlDevice(id, z3k_config, z3k_state, {
                hide_relay,
            });
            if (!control_device) {
                return null;
            }
            const { icon } = control_device;
            return icon;
        }) }));
});
